import React, { useContext, useState, useEffect } from "react";
import { Button, Result, Statistic } from "antd";
import language from "../../resources/languages/fa_IR";
import { ActionType, API, Enum } from "../../resources/constants"

// Contexts
import GlobalContext from '../../contexts/global';
import AxiosContext from "../../contexts/axios"

// Interfaces
import { AxiosError, AxiosResponsePaginate } from "../../interfaces/axios"

const { Components: { Payment }, Message: MessageLanguage } = language
const { Message, Form, TravelMod } = Enum
const { SET_OPEN_DRAWER, SET_FORM, SET_TRAVEL, SET_TRAVEL_MOD } = ActionType
const { Countdown } = Statistic
const { TRAVEL_TRAVEL_MY_PAGINATE } = API
const urlParams = new URLSearchParams(window.location.search)
const payment = urlParams.get('payment');
const travel = urlParams.get('travel');

export default function Index() {

    const { dispatch } = useContext(GlobalContext)
    const { axios } = useContext(AxiosContext)
    const [loading, setLoading] = useState<boolean>(false)

    const success = () => {
        setLoading(true)
        axios.post(TRAVEL_TRAVEL_MY_PAGINATE, { travel }, { params: { page: 1, limit: 1 }}).then((response: AxiosResponsePaginate) => {
            const { data, data: { docs } } = response
            const travel =  docs.length ? { ...docs[0], paginate: { ...data, docs: null } } : {}
            dispatch({ type: SET_TRAVEL , payload: { travel }})
            dispatch({ type: SET_TRAVEL_MOD , payload: { travelMod: TravelMod.MY }})
            dispatch({ type: SET_FORM , payload: { form: Form.TICKET }})
            setLoading(false)
        }).catch( (error: AxiosError) => {
            const { response: { data } } = error;
            dispatch({ type: SET_TRAVEL , payload: { travel: {} }})
            dispatch({ type: SET_TRAVEL_MOD , payload: { travelMod: TravelMod.MY }})
            setLoading(false)
            // @ts-ignore
            message.error(MessageLanguage[Message.ERROR_SEARCH]).then(response => response)
        })
    }

    const error = () => dispatch({ type: SET_OPEN_DRAWER, payload: { openDrawer: false }})

    useEffect(() => {
        window.history.pushState({}, '', '/')
    }, [])

    return (payment === "success" && travel) ? (
        <Result
            status="success"
            title={Payment.successTitle}
            subTitle={Payment.successDescription}
            extra={<Button type="primary" icon={<Countdown className='payment-countdown' value={Date.now() + 10000} format="s" onFinish={success} />} loading={loading} onClick={success}>{Payment.ticket}</Button>}
        />
    ) : (payment === "error") ? (
        <Result
            status="error"
            title={Payment.errorTitle}
            subTitle={Payment.errorDescription}
            extra={<Button icon={<Countdown className='payment-countdown' value={Date.now() + 10000} format="s" onFinish={error} />} onClick={error}>{Payment.home}</Button>}
        />
    ) : (
        <Result
            status="warning"
            title={Payment.warningTitle}
            subTitle={Payment.warningDescription}
            extra={<Button icon={<Countdown className='payment-countdown' value={Date.now() + 10000} format="s" onFinish={error} />} onClick={error}>{Payment.home}</Button>}
        />
    )
}
